import React from "react";
import { ConfigProvider } from "antd";
import Routes from "./routes";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./hooks/auth";
import ThemedGlobalStyle from "./styles/global";
import { ToastContainer } from "./components/ui/toast";
import { ReportBuilderProvider } from "./contexts/ReportBuilderContext";
import { useThemeLoader } from "./hooks/useThemeLoader";
import { useMixpanelTracking } from "./hooks/useMixpanelTracking";
import { useAntdThemeConfig } from "./hooks/useAntdThemeConfig";

/**
 * Componente principal da aplicação com lógica de tema e tracking
 */
const AppContent = () => {
  // Hooks customizados para separar responsabilidades
  useThemeLoader(); // Gerencia carregamento de temas
  useMixpanelTracking(); // Gerencia tracking de analytics
  const themeConfig = useAntdThemeConfig(); // Configuração do tema Ant Design

  return (
    <ConfigProvider theme={themeConfig}>
      <ReportBuilderProvider>
        <Routes />
      </ReportBuilderProvider>
      <ToastContainer />
    </ConfigProvider>
  );
};

/**
 * Componente raiz da aplicação com providers
 */
const App = () => {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
        <ThemedGlobalStyle />
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
